import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { ExpenseCategory } from '../state-man/models/expense-type.model';
import { UiService } from './ui.service';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root'
})
export class ExpenseCategoryService {

  constructor(
    private apiService: ApiService,
    private uiService: UiService
  ) { }

  // version: the one that came with the list already held, or '' for none.
  public async getAll (version: string) : Promise<{ version: string, rows: ExpenseCategory[] | null } | null> {      
    try {
      const ret = await this.apiService.getVersionedList('expenses/expense_categories/', version)
      return ret && { version: ret.version, rows: ret.rows && ExpenseCategory.buildMany(ret.rows) }
    } catch (error) {   
      LoggerService.log(error + 'expense_categories/')   
      await this.uiService.showToast('An unexpected error occurred and has been sent to the support team.')     
      return null
    }
  }  
  
}
